export const nullFilter = (store, action, array) => {
    let array2 = [];
    for (let i = 0; i < array.length - 1; i++) {
        array2.push(array[i])
        let raz = array[i].x - array[i + 1].x
        let point = Math.floor(raz / 120000)
        if (raz > 120000) {
            let a = array[i].x
            for (let i = 0; i < point; i++) a = a + 120000
            array2.push({x: a, y: null})
        }
    }
    store.setData(action, array2)
}